import React from 'react';
export function CellularResetSection() {
  return <section className="py-4 md:py-14 px-6 bg-white" data-id="element-23">
      <div className="max-w-4xl mx-auto text-center" data-id="element-24">
        <span className="text-accent font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-25">
          La Ciencia Detrás del Método
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-navy mb-6 leading-tight" data-id="element-26">
          Cómo ocurre el <span className="text-accent" data-id="element-27">Reset Biológico</span>
          <br className="hidden md:block" data-id="element-28" />
          <span className="text-navy/70 text-2xl md:text-3xl font-medium" data-id="element-29">
            {' '}
            (Visualización Celular)
          </span>
        </h2>
        <p className="text-lg md:text-xl text-navy/80 leading-relaxed max-w-3xl mx-auto mb-10" data-id="element-30">
          Este protocolo{' '}
          <strong className="text-navy" data-id="element-31">no es teoría abstracta</strong>. Es una{' '}
          <span className="text-accent font-semibold" data-id="element-32">
            optimización directa de tu motor celular
          </span>{' '}
          (mitocondria) para despejar la{' '}
          <strong className="text-navy" data-id="element-33">neuro-inflamación</strong> que nubla tu
          juicio.
        </p>

        {/* Infographic Image */}
        <div className="relative" data-id="element-34">
          <div className="absolute -inset-4 bg-navy/5 rounded-3xl blur-xl" data-id="element-35"></div>
          <img src="https://cdn.magicpatterns.com/uploads/neS8gtBFo4LGzYguuR2BMn/antes-despues.jpg" alt="Visualización celular: Antes (sistema bloqueado con niebla mental, energía intermitente e ineficiencia metabólica) vs Después (sistema reseteado con claridad de acero, energía constante y quema de grasa natural)" className="relative w-full max-w-3xl mx-auto rounded-2xl shadow-2xl animate-subtle-pulse" data-id="element-36" />
        </div>

        {/* Caption */}
        <p className="mt-6 text-sm text-navy/50 italic max-w-2xl mx-auto" data-id="element-37">
          Tu mitocondria <strong className="text-navy/70" data-id="element-38">antes</strong> del
          protocolo (bloqueada, generando niebla y cansancio) vs{' '}
          <strong className="text-navy/70" data-id="element-39">después</strong> de las{' '}
          <strong className="text-navy/70" data-id="element-40">72 horas</strong> (reseteada,
          produciendo energía limpia y optimizando el combustible celular).
        </p>
      </div>
    </section>;
}